// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../data/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Bulma Utilities */\n.datepicker-holder[data-v-db6ff2e2] {\n  width: 240px;\n}\n", ""]);
// Exports
module.exports = exports;
